import { Pagination, Pixel, Signal, SignalType } from "@types";

export enum DateRangeDefaults {
  All = "||all",
  Custom = "||custom",
}

export interface SignalsState {
  isLoading: {
    signals: boolean;
    threadAccessEvents: boolean;
    viewedSignals: boolean;
    readSignals: boolean;
    threadTrackStatus: boolean;
    pixel: boolean;
    emailSentEvent: boolean;
  };
  isError: {
    signals: boolean;
    threadAccessEvents: boolean;
    viewedSignals: boolean;
    readSignals: boolean;
    threadTrackStatus: boolean;
    pixel: boolean;
    emailSentEvent: boolean;
  };
  pagination: Pagination & {
    notViewedSignalsCount: number;
    unreadSignalsCount: number;
  };
  filters: {
    dateRangeString: DateRangeDefaults | string;
    eventName: SignalType[];
  };
  results: Signal[];
  selectedSignal: Signal | null;
  pixel: Pixel | null;
}
